import { fetchCurrencyList } from '#/api/system/currency/fetchList';

export function mapCurrencyRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: [row.code, row.name].filter(Boolean).join(' - ') || String(row.id),
  }));
}

/**
 * ACTIVE 幣別 select options（採購等）。
 * Label：`{code} - {name}`；`lookupQueryKey('currencySelect')`。
 */
export async function fetchCurrencySelectOptions() {
  const { data } = await fetchCurrencyList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [{ id: 'code', desc: false }],
    filters: { status: 'ACTIVE' },
  });

  return mapCurrencyRowsToSelectOptions(data ?? []);
}
